import * as Sentry from '@sentry/react'
import { registerSW } from 'virtual:pwa-register'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const updateSW = registerSW({
  onOfflineReady() {
    // La app está lista para funcionar sin conexión; el toast se muestra
    // solo en la primera activación del SW (instalación inicial o tras limpiar caché).
    import('sonner').then(({ toast }) => {
      toast.success('La app está lista para usarse sin conexión.')
    })
  },
  onNeedRefresh() {
    // Nueva versión disponible; con autoUpdate el SW toma control solo,
    // pero confirmamos el reload para que el usuario no sea sorprendido.
    import('sonner').then(({ toast }) => {
      toast.info('Nueva versión disponible. Actualizando...', {
        duration: 3000,
        onAutoClose: () => updateSW(true),
      })
    })
  },
  onRegisterError(error) {
    Sentry.captureException(error, { tags: { source: 'sw-registration' } })
  },
})

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: __APP_VERSION__,
  enabled: Boolean(import.meta.env.VITE_SENTRY_DSN),
})

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('No se encontró el elemento #root en el DOM')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
